<template>
  <div class="d-flex flex-wrap">
    <div>
      <h5>
        All Sellers in Category
      </h5>
      <div class="d-flex flex-column seller-offer-registration-list mr-5 mb-3">
        <div v-if="allSellersInCategory.length">
          <div
            v-for="seller in allSellersInCategory"
            :key="seller.id"
            class="seller-offer-registration-list__item pl-3"
          >
            <div class="d-flex">
              <router-link
                target="_blank"
                title="View Account"
                class="text-truncate seller-offer-registration-list__item-account-name h5 mb-0"
                :to="{
                  name: 'SellerAccountDetails',
                  params: { id: seller.id },
                  exact: true,
                }"
              >
                {{ seller.name }}
                <CIcon
                  name="cil-external-link"
                  size="custom"
                  class="ml-1"
                />
              </router-link>
              <a
                href
                title="Copy Account Id"
                class="ml-2"
                @click.prevent="
                  copyAccountIdToClipboard(seller.id)
                "
              ><CIcon
                name="cil-copy"
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import copyToClipboardMixin from '@/mixins/copy-to-clipboard-mixin'
import { showSuccessMessage } from '@/notification-utils'

export default {
  name: 'CategorySupplyAllSellers',

  mixins: [copyToClipboardMixin],

  props: {
    allSellersInCategory: {
      type: Array,
      default() {
        return []
      }
    },

  },

  data() {
    return {
    }
  },

  computed: {
  },

  methods: {
    copyAccountIdToClipboard(id) {
      this.copyTextToClipboard(id)
      showSuccessMessage('Account ID copied to clipboard')
    },
  }
}
</script>
<style lang="scss" scoped>
</style>